type DocImageProps = {
  alt: string;
  caption?: string;
  height: number;
  maxWidth?: number;
  src: string;
  width: number;
};

export function DocImage({
  alt,
  caption,
  height,
  maxWidth,
  src,
  width,
}: DocImageProps) {
  return (
    <figure className="kaleo-doc-image" style={{ maxWidth }}>
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading="lazy"
        decoding="async"
      />
      {caption ? <figcaption>{caption}</figcaption> : null}
    </figure>
  );
}
